import { render, staticRenderFns } from "./AppListUserRole.vue?vue&type=template&id=07ad094d"
import script from "./AppListUserRole.vue?vue&type=script&lang=js"
export * from "./AppListUserRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports